<template>
  <div class="rounded-full py-2 px-6" :class="classes">
    <label v-if="showLabel" :for="id" class="hidden md:inline-block">{{label}} </label>
    <select :name="id" :id="id" class="bg-transparent" @change="onChange($event)">
      <option value="" disabled selected>---</option>
      <option v-for="(option, index) in options" :key="index"
        :value="option.value">{{option.text}}</option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    classes: {
      type: String,
      required: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      required: false,
    },
    id: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedOption: '',
    };
  },
  methods: {
    onChange(event) {
      this.$emit('changed', event.target.value);
    },
  },
};
</script>

<style>

</style>
